export enum AccessLevel {
  hidden = 0,
  disabled = 1,
  readOnly = 2,
  actionable = 3,
  enterable = 4,
}
